"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Recession = void 0;
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const PreludeCard_1 = require("../prelude/PreludeCard");
const Resources_1 = require("../../Resources");
class Recession extends PreludeCard_1.PreludeCard {
    constructor() {
        super({
            name: CardName_1.CardName.RECESSION,
            metadata: {
                cardNumber: 'P59',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.megacredits(-5).any;
                    b.production((pb) => pb.megacredits(-1).any);
                    b.megacredits(10);
                }),
                description: 'EACH OPPONENT loses 5 M€ and decreases their M€ production 1 step. You gain 10 M€.',
            },
        });
    }
    play(player) {
        const opponents = player.game.getPlayers().filter((p) => p.id !== player.id);
        for (const p of opponents) {
            p.deductResource(Resources_1.Resources.MEGACREDITS, 5, { log: true, from: player });
            p.addProduction(Resources_1.Resources.MEGACREDITS, -1, { log: true, from: player });
        }
        player.addResource(Resources_1.Resources.MEGACREDITS, 10);
        return undefined;
    }
}
exports.Recession = Recession;
//# sourceMappingURL=Recession.js.map